import { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loading-overlay-ts";

class Loader extends Component {
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.info.loadings !== this.props.info.loadings ||
            this.props.authorizedAppsIsLoading !== nextProps.authorizedAppsIsLoading
        );
    }

    render() {
        let nbCurrentLoadings = 0;
        for (var propertyName in this.props.info.loadings) {
            if (this.props.info.loadings[propertyName] && this.props.info.loadings[propertyName].isLoading)
                nbCurrentLoadings++;
        }

        return (
            <Loadable
                className={
                    "loader center-screen" +
                    (nbCurrentLoadings > 0 || this.props.authorizedAppsIsLoading ? " active-loader" : "")
                }
                active={nbCurrentLoadings > 0 || this.props.authorizedAppsIsLoading}
                spinner
                color={"#FE5815"}
                background={""}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        zIndex: 1500,
                    }),
                }}
                text="Chargement en cours..."
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authorizedAppsIsLoading: state.authorizedAppsIsLoading,
        info: state.info,
        context: state.context,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Loader);
